<template>
  <div class="form-filter-log">
    <b-form-group v-if="isFilterDetail">
      <label>Block ID</label>
      <j-input
        v-model="dataForm.blockId"
        placeholder="Block ID"
      />
    </b-form-group>

    <b-form-group v-else>
      <label>Time Range</label>
      <div class="time-range">
        <j-date-time
          :data="dataForm.startDate"
          type="datetime"
          placeholder="Start Date Time"
          format="MMM dd, yyyy, HH:mm"
          @getTimestamp="setValueDateAndAtime($event, 'startDate')"/>
        <j-date-time
          :data="dataForm.endDate"
          type="datetime"
          placeholder="End Date Time"
          format="MMM dd, yyyy, HH:mm"
          @getTimestamp="setValueDateAndAtime($event, 'endDate')"/>
      </div>
    </b-form-group>

    <b-form-group>
      <label>Status</label>
      <j-single-select
        v-model="dataForm.status"
        :options="statusOptions"
        placeholder="Select Status"
        label="label"
      />
    </b-form-group>

    <b-form-group>
      <label>Total Runtime (in millisecond)</label>
      <div class="runtime">
        <j-single-select
          v-model="dataForm.runtime.operator"
          :options="operatorOptions"
          placeholder="Operator"
          label="label"
        />
        <j-input
          v-model="dataForm.runtime.value"
          type="number"
          placeholder="Total Runtime in millisecond"
        />
      </div>
    </b-form-group>

    <div class="action-form">
      <button
        class="button-grey"
        @click="resetDataForm()"
      >
        Reset
      </button>
      <button
        class="button-blue"
        @click="applyFilter()"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import jDateTime from '@/components/inputs/jDateTime';

export default {
  components: {
    jDateTime,
  },

  props: {
    isFilterDetail: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataForm: {
        blockId: '',
        startDate: null,
        endDate: null,
        status: null,
        runtime: {
          operator: null,
          value: null,
        },
      },

      statusOptions: [
        {
          id: 'success',
          label: 'Success',
          text: 'success',
        },
        {
          id: 'running',
          label: 'Running',
          text: 'running',
        },
        {
          id: 'error',
          label: 'Error',
          text: 'error',
        },
      ],

      operatorOptions: [
        {
          id: 'equal_to',
          label: 'Equal To',
          text: 'equal_to',
        },
        {
          id: 'less_than',
          label: 'Less Than',
          text: 'less_than',
        },
        {
          id: 'greater_than',
          label: 'Greater Than',
          text: 'greater_than',
        },
      ],
    };
  },

  methods: {
    setValueDateAndAtime(data, type) {
      this.dataForm[type] = data;
    },

    applyFilter() {
      const { blockId, startDate, endDate, status } = this.dataForm;
      const filter = this.isFilterDetail ?
        {
          action_id: blockId || null,
          status,
          runtime: this.setFilterRuntime(),
        } :
        {
          date: startDate && endDate ? {
            start_date: this.formatDate(startDate),
            end_date: this.formatDate(endDate),
          } : null,
          status,
          runtime: this.setFilterRuntime(),
        };

      const cleanedFilter = this.cleanFilter(filter);
      this.$emit('apply-filter', cleanedFilter);
    },

    formatDate(epoch) {
      return this.$moment(epoch).utc().format('YYYY-MM-DD HH:mm:ss');
    },

    setFilterRuntime() {
      const { operator, value } = this.dataForm.runtime;

      const operatorMapping = {
        less_than: { $lte: Number(value) },
        greater_than: { $gte: Number(value) },
      };

      return operatorMapping[operator] || Number(value) || null;
    },

    cleanFilter(filter) {
      const cleanedFilter = {};

      Object.keys(filter).forEach((key) => {
        const value = filter[key];
        if (value !== null && value !== undefined) {
          if (typeof value === 'object' && !Array.isArray(value)) {
            cleanedFilter[key] = this.cleanNestedObjectFilter(value);
          } else {
            cleanedFilter[key] = value;
          }
        }
      });

      return cleanedFilter;
    },

    cleanNestedObjectFilter(nestedObject) {
      const cleanedNestedObject = {};

      Object.keys(nestedObject).forEach((subKey) => {
        if (nestedObject[subKey] !== null && nestedObject[subKey] !== undefined) {
          cleanedNestedObject[subKey] = nestedObject[subKey];
        }
      });

      return cleanedNestedObject;
    },

    resetDataForm() {
      this.dataForm.blockId = '';
      this.dataForm.startDate = null;
      this.dataForm.endDate = null;
      this.dataForm.status = null;
      this.dataForm.runtime = {
        operator: null,
        value: null,
      };
      this.$emit('reset-filter');
    },
  },
};
</script>

<style lang="scss" scoped>
.form-filter-log {
  label {
    font-family: 'Poppins-Regular';
    font-size: 12px;
    color: #808285;
  }

  .time-range {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;
  }

  .runtime {
    display: grid;
    grid-template-columns: 120px 1fr;
    grid-gap: 8px;
  }

  .action-form {
    display: grid;
    grid-template-columns: 98px 1fr;
    grid-gap: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/visual-programming/popover/jPopoverFilterRunHistory.vue